import styled from "styled-components";

export const Bloco = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
`;

export const Titulo = styled.h3`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textSecondary};
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Observacao = styled.div`
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  color: ${({ theme }) => theme.textPrimary};
  white-space: pre-wrap;
  overflow-wrap: anywhere;

  span {
    display: block;
    font-size: 11px;
    font-weight: 600;
    color: ${({ theme }) => theme.textSecondary};
    margin-bottom: 4px;
  }
`;

export const Aviso = styled.p`
  margin: 0;
  border: 1px solid var(--warning-border);
  background: var(--warning-bg);
  color: var(--warning-text);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
`;

export const Erro = styled(Aviso)`
  border-color: var(--danger-border);
  background: var(--danger-bg);
  color: var(--danger-text);
`;

export const Formulario = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  textarea {
    width: 100%;
    min-height: 72px;
    resize: vertical;
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: 10px;
    padding: 8px 10px;
    font: inherit;
    font-size: 14px;
    color: ${({ theme }) => theme.textPrimary};
    background: ${({ theme }) => theme.surface};
  }
`;

export const LinhaDeAcoes = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;

  .dica {
    margin-right: auto;
    font-size: 12px;
    color: ${({ theme }) => theme.textSecondary};
  }
`;

export const Lista = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Item = styled.li`
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const Cabecalho = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};

  strong {
    font-size: 13px;
    color: ${({ theme }) => theme.textPrimary};
  }
`;

export const Texto = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: ${({ theme }) => theme.textPrimary};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

export const Selos = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

export const Selo = styled.span`
  font-size: 11px;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 999px;
  padding: 1px 8px;
  color: ${({ theme }) => theme.textSecondary};
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BotaoTexto = styled.button`
  background: none;
  border: none;
  padding: 2px 4px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme, $perigo }) => ($perigo ? "var(--danger-text)" : theme.textSecondary)};
  cursor: pointer;
  min-height: var(--tap-min, 32px);

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const Vazio = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.textSecondary};
`;

export const Balao = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 6px;
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.textSecondary};
  vertical-align: middle;
`;
